import React from 'react';
import { Link } from "react-router-dom";

const SubmitYourTestModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  rows,
  timeLeft
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999] px-3 animate-in fade-in duration-300">
      {/* Container: Max height added for mobile scrolling */}
      <div className="bg-white w-full max-w-[1100px] rounded-xl shadow-lg overflow-hidden max-h-[95vh] flex flex-col">

        {/* Header: Responsive flex direction */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between px-6 py-4 gap-3">
          <h2 className="text-[20px] md:text-[24px] tracking-[-1px] font-[500] text-[#333333]">
            {title || ' Submit your Test'}
          </h2>

          <span className="bg-[#4096F6] text-white font-[500] text-[14px] md:text-[16px] px-3 py-2 rounded-[4px] whitespace-nowrap">
            Time Left {timeLeft}
          </span>
        </div>

        {/* Table Wrapper: Horizontal scroll for mobile */}
        <div className="p-6 overflow-x-auto custom-scrollbar flex-1">
          <table className="w-full border border-[#333333] text-center min-w-[800px]">
            <thead className="bg-[#E6F2FF]">
              <tr className="font-[400] text-[15px] md:text-[18px] text-[#333333] tracking-tight">
                <th className="border border-[#333333] px-3 py-3 md:py-5 text-left">Section</th>
                <th className="border border-[#333333] px-2 py-3 md:py-5">No. of Question</th>
                <th className="border border-[#333333] px-2 py-3 md:py-5">Answered</th>
                <th className="border border-[#333333] px-2 py-3 md:py-5">Not Answered</th>
                <th className="border border-[#333333] px-2 py-3 md:py-5">Marked for Review</th>
                <th className="border border-[#333333] px-2 py-3 md:py-5">Not Visited</th>
              </tr>
            </thead>

            <tbody>
              {
                rows.map((row, i) => (
                  <tr key={i} className="font-[500] text-[#333333] text-[14px] md:text-[16px] tracking-tight" >
                    <td className="border border-[#333333] px-3 py-3 md:py-5 text-left font-semibold">{row.section}</td>
                    <td className="border border-[#333333] px-2 py-3 md:py-5">{row.total}</td>
                    <td className="border border-[#333333] px-2 py-3 md:py-5">{row.answered}</td>
                    <td className="border border-[#333333] px-2 py-3 md:py-5">{row.notAnswered}</td>
                    <td className="border border-[#333333] px-2 py-3 md:py-5">{row.review}</td>
                    <td className="border border-[#333333] px-2 py-3 md:py-5">{row.notVisited}</td>
                  </tr>
                ))
              }

              {/* {rows.map((row, i) => (
                <tr key={i} className="font-[500] text-[#333333] text-[14px] md:text-[16px] tracking-tight">
                  <td className="border border-[#333333] px-3 py-3 md:py-5 text-left font-semibold">
                    {row.section}
                  </td>
                  <td className="border border-[#333333] px-2 py-3 md:py-5">{row.total}</td>
                  <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
                  <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
                  <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
                  <td className="border border-[#333333] px-2 py-3 md:py-5">{row.total}</td>
                </tr>
              ))} */}
            </tbody>
          </table>
        </div>

        {/* Footer buttons: Full width on mobile */}
        <div className="flex flex-col sm:flex-row justify-end gap-3 px-6 py-4 border-t border-[#000000]">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-2.5 bg-[#4096F6] text-white rounded-[4px] text-[15px] md:text-[16px] font-[500] tracking-tight hover:bg-blue-700 transition-colors active:scale-95"
          >
            Close
          </button>

          <button
            onClick={onSubmit}
            className="w-full sm:w-auto text-center px-8 py-2.5 bg-[#4096F6] text-white rounded-[4px]"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};


// const SubmitYourTestModal = ({ isOpen, onClose, onSubmit }) => {
//   if (!isOpen) return null;

//   const rows = [
//     { section: "General Intelligence and Reasoning", total: 25 },
//     { section: "General Awareness", total: 25 },
//     { section: "Quantitative Aptitude", total: 25 },
//     { section: "English Comprehension", total: 25 },
//   ];

//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999] px-3 animate-in fade-in duration-300">
//       {/* Container: Max height added for mobile scrolling */}
//       <div className="bg-white w-full max-w-[1100px] rounded-xl shadow-lg overflow-hidden max-h-[95vh] flex flex-col">

//         {/* Header: Responsive flex direction */}
//         <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between px-6 py-4 gap-3">
//           <h2 className="text-[20px] md:text-[24px] tracking-[-1px] font-[500] text-[#333333]">
//             Submit your Test
//           </h2>

//           <span className="bg-[#4096F6] text-white font-[500] text-[14px] md:text-[16px] px-3 py-2 rounded-[4px] whitespace-nowrap">
//             Time Left 2 Min
//           </span>
//         </div>

//         {/* Table Wrapper: Horizontal scroll for mobile */}
//         <div className="p-6 overflow-x-auto custom-scrollbar flex-1">
//           <table className="w-full border border-[#333333] text-center min-w-[800px]">
//             <thead className="bg-[#E6F2FF]">
//               <tr className="font-[400] text-[15px] md:text-[18px] text-[#333333] tracking-tight">
//                 <th className="border border-[#333333] px-3 py-3 md:py-5 text-left">Section</th>
//                 <th className="border border-[#333333] px-2 py-3 md:py-5">No. of Question</th>
//                 <th className="border border-[#333333] px-2 py-3 md:py-5">Answered</th>
//                 <th className="border border-[#333333] px-2 py-3 md:py-5">Not Answered</th>
//                 <th className="border border-[#333333] px-2 py-3 md:py-5">Marked for Review</th>
//                 <th className="border border-[#333333] px-2 py-3 md:py-5">Not Visited</th>
//               </tr>
//             </thead>

//             <tbody>
//               {rows.map((row, i) => (
//                 <tr key={i} className="font-[500] text-[#333333] text-[14px] md:text-[16px] tracking-tight">
//                   <td className="border border-[#333333] px-3 py-3 md:py-5 text-left font-semibold">
//                     {row.section}
//                   </td>
//                   <td className="border border-[#333333] px-2 py-3 md:py-5">{row.total}</td>
//                   <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
//                   <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
//                   <td className="border border-[#333333] px-2 py-3 md:py-5">0</td>
//                   <td className="border border-[#333333] px-2 py-3 md:py-5">{row.total}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Footer buttons: Full width on mobile */}
//         <div className="flex flex-col sm:flex-row justify-end gap-3 px-6 py-4 border-t border-[#000000]">
//           <button
//             onClick={onClose}
//             className="w-full sm:w-auto px-8 py-2.5 bg-[#4096F6] text-white rounded-[4px] text-[15px] md:text-[16px] font-[500] tracking-tight hover:bg-blue-700 transition-colors active:scale-95"
//           >
//             Close
//           </button>

//           <Link to="/test-result"
//             onClick={onSubmit}
//             className="w-full sm:w-auto text-center px-8 py-2.5 bg-[#4096F6] text-white rounded-[4px] text-[15px] md:text-[16px] font-[500] tracking-tight hover:bg-blue-700 transition-colors active:scale-95"
//           >
//             Submit
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

export default SubmitYourTestModal;